    <div class="layer">
        <div class="role-main-tabs d-none"><!-- Add d-flex when tabs are ready to use -->
            <div
            (click)="notifyTabChange('general')"
            class="role-tab {{activeTab === 'general' ? 'active-tab': ''}}">
                {{ 'roles.generalTab' | translate }}
            </div>
            <div
            (click)="notifyTabChange('form')"
            class="role-tab {{activeTab === 'form' ? 'active-tab': ''}}" >
                {{ 'roles.form' | translate }}
            </div>
            <div
            (click)="notifyTabChange('statuses')"
            class="role-tab {{activeTab === 'statuses' ? 'active-tab': ''}} d-flex align-items-center" >
                {{ 'roles.statuses' | translate }}
                <span *ngIf="activeTab === 'statuses'" class="addBtn services-icon--add ml-3">{{ 'roles.statusAdd' | translate }}</span>
            </div>
        </div>
        <div class="role-main-tabs-content">
            <div class="role-tab-content tab-general {{activeTab === 'general' ? 'active-tab': ''}}">
                <form-description [form]="applicantForm" [determinantMapById]="determinantMapById"
                                  (saveForm)="saveForm(applicantForm.formSchema);"></form-description>
            </div>
            <div class="{{this.store.state.common.lockedPageByUser ? 'locked-page' : ''}}"><!-- Add this when tabs are ready to use: class="role-tab-content tab-form {{activeTab === 'form' ? 'active-tab': ''}} {{this.store.state.common.lockedPageByUser ? 'locked-page' : ''}}" -->
                <div class="page-locker" *ngIf="this.store.state.common.lockedPageByUser"> </div>
                <div><!-- Add this when tabs are ready to use: class="p-4" -->
                    <div class="row form-main-actions w-100 preview-button-container-sticky mt-0 py-2 align-content-center" *ngIf="serviceId && store.state.common.userLevels.pages && store.state.common.userLevels.pages.SideNavLevel >= 2">
                        <div class="col-sm-12 closer-form">
                            <span class="align-buttons"></span>
                            <!--
                            <span class="ml-auto align-buttons">
                                <span class="btn btn-light btn-rounded btn-md text-uppercase align-self-center form-fields-btn mr-2" (click)="showFieldsGenerator = true">
                                    {{ "Go to Generate Fields" | translate }}
                                </span>
                            </span>
                            -->
                            <!--<user-level [page]="'ApplicantForm'" [levelLabel]="'level.user'" class="d-flex text-right ml-auto mr-3"></user-level>-->
                            <form-builder-actions
                                class="ml-auto"
                                [serviceId]="serviceId"
                                [myFormio]="myFormio"
                                [formKey]="'applicant-form'"
                                [downloadHandler]="downloadSchema.bind(this)"
                                [historyHandler]="openHistory.bind(this)"
                                [historyLabelKey]="'Form history'"
                                [copyLabelKey]="'Copy'"
                                [minUserLevel]="2"
                                [downloadLabelKey]="'Copy form schema with relations'">
                            </form-builder-actions>
                            <tutorial-layer
                                    *ngIf="applicantForm && applicantForm.tutorials && applicantForm.tutorials.general"
                                    class="inpage-tutorial inline-tutorial-button pull-right"
                                    title="{{ 'Applicant form' | translate }}"
                                    [isClosed]="true"
                                    [editorData]="applicantForm.tutorials.general"
                                    (saveTutorial)="saveTutorial($event)">
                            </tutorial-layer>
                        </div>
                    </div>
                    <my-formio #myFormio [serviceId]="serviceId" [formSchema]="applicantForm.formSchema" formType="applicantform"
                               [determinantMapById]="determinantMapById"
                               [pasteWithTransformationEnabled]="true"
                               [focusCompKey]="focusCompKey"
                               [fileLinkableWithRequirement]="true" formName="applicant"
                               (saveFormSchema)="saveForm($event)"
                               class="applicant-form-builder form-with-preview"></my-formio>
                </div>
            </div>
            <div class="role-tab-content tab-statuses {{activeTab === 'statuses' ? 'active-tab': ''}}">

            </div>
        </div>
        <fields-generator *ngIf="showFieldsGenerator"
            (modalClosedEvent)="showFieldsGenerator = false"
            [embedded]="true"
            [ngStyle]="style"
            mwlResizable
            [enableGhostResize]="true"
            [resizeEdges]="{ bottom: false, right: false, top: false, left: true }"
            (resizeEnd)="onResizeEnd($event)"
            class="layer half-layer px-3">
    </fields-generator>
    <div class="shadow"></div>
</div>

<app-history-form
    *ngIf="showHistory"
    [serviceId]="serviceId"
    [determinantMapById]="determinantMapById"
    [historyController]="applicantFormController"
    (changeForm)="changeForm($event)"
    (closeLayer)="closeHistory()">
</app-history-form>
